import React, { useMemo } from 'react'
import { ReportPreview } from './ReportPreview'
import { buildReportPreviewPayload } from '@utils/report.util'
import { getProviderName } from '@utils/report-schema-helper'
import { useReportMetricsSchema } from '@hooks/reports/useReportMetricsSchema'
import { useSignedBlobUrl } from '@hooks/useSignedBlobUrl'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'

type ReportPreviewContainerProps = {
  selectedClinic: any
  reportTitle: string
  reportFiltersAndMetrics: any
  generatedOnDisplay: string
  headerSwitch: boolean
  isCustomReport: boolean
  payloadData?: any
}

const ReportPreviewContainer: React.FC<ReportPreviewContainerProps> = ({
  selectedClinic,
  reportTitle,
  reportFiltersAndMetrics,
  generatedOnDisplay,
  headerSwitch,
  isCustomReport,
  payloadData,
}) => {
  const sourceMetricsSchema = useReportMetricsSchema()
  const clinicLogoUrl = useSignedBlobUrl(selectedClinic?.logo_url, '')
  const providers = useSelector((state: RootState) => state.provider.data)
  const selectedProviderFilter =
    reportFiltersAndMetrics?.filters?.['provider-filter']
  const providerName =
    selectedProviderFilter === 'all-providers'
      ? 'All providers'
      : getProviderName(
          providers.find(
            (provider) => provider.provider_id === selectedProviderFilter,
          ),
        )
  const payload = useMemo(
    () =>
      buildReportPreviewPayload({
        selectedClinic,
        reportTitle:
          sourceMetricsSchema.find((metric) => metric.type === reportTitle)
            ?.pageTitle || reportTitle,
        reportFiltersAndMetrics,
        generatedOnDisplay,
        headerSwitch,
        isCustomReport,
        sourceMetricsSchema,
        payloadData,
        providerName,
        clinicLogoUrl,
      }),
    [
      selectedClinic,
      reportTitle,
      reportFiltersAndMetrics,
      generatedOnDisplay,
      headerSwitch,
      isCustomReport,
      sourceMetricsSchema,
      payloadData,
      providerName,
      clinicLogoUrl,
    ],
  )

  return <ReportPreview payload={payload} />
}

export default ReportPreviewContainer
